import { PracticePitcherSingleSessionReportChartConfigDto, PitcherStatsByPitchType, TableChartConfigDto } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';

const disabledVisibleStats: (keyof PitcherStatsByPitchType)[] = ['pitchType'];

const PracticePitcherSingleSessionStatsByPitchTypeChartSidebar = (
  props: ChartConfigProps<TableChartConfigDto, PracticePitcherSingleSessionReportChartConfigDto>
) => {
  return (
    <TableChartSidebar
      chartId='PracticePitcherSingleSessionStatsByPitchTypeChart'
      configKey='practicePitcherSingleSessionStatsByPitchTypeChartConfig'
      disabledVisibleStats={disabledVisibleStats}
      {...props}
    />
  );
};

export default PracticePitcherSingleSessionStatsByPitchTypeChartSidebar;
